import { FormWidgetBase } from './shared/form-widget-base';

class RedirectWidget extends FormWidgetBase {
    async submit() {
        const urlParams = new URLSearchParams(window.location.search);

        Object.entries(this.elements).forEach(([fieldName, element]) => {
            if (element.input) {
                urlParams.set(`mh-${fieldName}`, element.input.value);
            }
        });

        if (`url` in this.config) {
            window.location.href = `${this.config.url}?${urlParams}`;
        }
    }
}

customElements.define(`mh-redirect`, RedirectWidget);

export default RedirectWidget;
